export class PdfOptions {
	public isTemporary: boolean;

	constructor(isTemporary: boolean) {
		this.isTemporary = isTemporary;
	}
}
